export default "__VITE_ASSET__Df$fx_cm__"